import { render, staticRenderFns } from "./IntranetPresentationTile.vue?vue&type=template&id=2c9c1723&scoped=true"
import script from "./IntranetPresentationTile.vue?vue&type=script&lang=js"
export * from "./IntranetPresentationTile.vue?vue&type=script&lang=js"
import style0 from "./IntranetPresentationTile.vue?vue&type=style&index=0&id=2c9c1723&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c1723",
  null
  
)

export default component.exports